import { gozokiApiWithAuth } from '../gozokiApi';

export const updateStudentPromoPercentage = async (studentPromoPercentage: number) => {
    const response = await gozokiApiWithAuth.patch(
        `/global-params/update-student-promo-percentage`,
        { studentPromoPercentage }
    );
    return response.data;
};
